<template>
    <div>

<!--        <div class="sidebar-section sidebar-section&#45;&#45;1 catalog">-->
<!--            <h3 class="sidebar-section__header">-->
<!--                Katalog-->
<!--            </h3>-->
<!--            <div class="sidebar-section__wrapper">-->
<!--                <TreeMenu theme="theme-catalog" :menu-items="menuItems">-->
<!--                    <template v-slot:default="{item, isOpen, isLeaf}">-->
<!--                        <i :class="[{ 'no-margin fas' : true}, { 'fa-plus': isLeaf == false && isOpen == false } , { 'fa-minus': isLeaf == false && isOpen == true }]"></i>-->
<!--                        <a class="link" :href="config.App.ServerRootAddress  + 'catalog/' + item.id">{{ item.name }}  </a>-->
<!--                    </template>-->
<!--                </TreeMenu>-->
<!--            </div>-->
<!--        </div>-->

        <div v-if="(minPrice > 0 || maxPrice > 0) && minPrice != maxPrice" class="sidebar-section sidebar-section--1 filter-range">
            <h3 class="sidebar-section__header">
                Cena
            </h3>
            <div class="sidebar-section__wrapper">

                <div class="filter-range-wrapper">
                  
                    <div class="price-slider">
                      <vue-slider v-model="priceSlider.model" :min="minPrice" :max="maxPrice" :tooltip="'always'"></vue-slider>
                    </div>
                  
                    <div class="filter-range__wrapper-in">
                        <input class="filter-range__input filter-range__lower" type="number" :min="minPrice" :max="maxPrice" v-model="priceSlider.model[0]" step="1">
                        <span class="filter-range__text">
                            -
                        </span>
                        <input class="filter-range__input filter-range__upper" type="number" :min="minPrice" :max="maxPrice" v-model="priceSlider.model[1]" step="1">
                        <span class="filter-range__text">
                            Kč
                        </span>
                    </div>

                  <div class="filter-range__wrapper-in">
                    <b-btn class="mh-filter-btn" :disabled="currentMinPrice === priceSlider.model[0] && currentMaxPrice === priceSlider.model[1]" @click="handlePriceFilter">Filtrovat</b-btn>
                  </div>

                </div>
            </div>
        </div>

        <div class="sidebar-section sidebar-section--1 manufacturer" v-if="filters.brands.length > 0">
            <h3 class="sidebar-section__header">
                Výrobce
            </h3>

            <div class="sidebar-section__wrapper">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                    id="checkbox-group-2"
                    v-model="mannufacturers.selected"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-2"
                    @change="handleBrandFilter"
                >
                  <b-form-checkbox v-for="option in filters.brands"
                                   :key="option.id"
                                   :value="option.id"
                                   name="flavour-4a"
                                   stacked>
                    {{ option.name }} <small>({{ option.count }})</small>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>

              
<!--              <b-form-group>-->
<!--                    <b-form-checkbox v-for="option in filters.brands"-->
<!--                                     v-model="mannufacturers.selected"-->
<!--                                     :key="option.id"-->
<!--                                     :value="option.id"-->
<!--                                     name="flavour-4a"-->
<!--                                     stacked>-->
<!--                        {{ option.name }} <small>({{ option.count }})</small>-->
<!--                    </b-form-checkbox>-->
<!--                </b-form-group>-->
            </div>
        </div>

<!--        <div class="sidebar-section sidebar-section&#45;&#45;1 avaliability">-->
<!--            <h3 class="sidebar-section__header">-->
<!--                Dostupnost-->
<!--            </h3>-->
<!--            <div class="sidebar-section__wrapper">-->
<!--                <b-form-group>-->
<!--                    <b-form-checkbox v-for="option in avaliability.options"-->
<!--                                     v-model="avaliability.selected"-->
<!--                                     :key="option.item"-->
<!--                                     :value="option.item"-->
<!--                                     name="flavour-4a"-->
<!--                                     stacked>-->
<!--                        {{ option.name }}-->
<!--                    </b-form-checkbox>-->
<!--                </b-form-group>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="sidebar-section sidebar-section&#45;&#45;1 flag">-->
<!--            <h3 class="sidebar-section__header">-->
<!--                Štítek-->
<!--            </h3>-->
<!--            <div class="sidebar-section__wrapper">-->
<!--                <b-form-group>-->
<!--                    <b-form-checkbox v-for="option in flags.options"-->
<!--                                     v-model="flags.selected"-->
<!--                                     :key="option.item"-->
<!--                                     :value="option.item"-->
<!--                                     name="flavour-4a"-->
<!--                                     stacked>-->
<!--                        {{ option.name }}-->
<!--                    </b-form-checkbox>-->
<!--                </b-form-group>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>

    import VueSlider from 'vue-slider-component'
    import TreeMenu from '@/common/components/treeMenu'
    import CatalogAPI from '@/common/api/eshop/shopping/catalog'
    import configService from '@/common/services/configService'
    import { EventBus } from '@/common/utils/event-bus'

    export default {
        components: { VueSlider, TreeMenu },
        data() {
            return {
                config: configService.config,
                menuItems: [],
                mannufacturers: {
                    selected: [],
                },
                avaliability: {
                    selected: [],
                    options: [
                        { item: 'A', name: 'Skladem' },
                        { item: 'B', name: 'Skladem u dodvatele' },
                        { item: 'D', name: 'Na zavolání' },
                    ]
                },
                flags: {
                    selected: [],
                    options: [
                        { item: 'n', name: 'Novinka' },
                        { item: 'f', name: 'Náš tip' },
                        { item: 'b', name: 'Akce' },
                    ]
                },
                priceSlider: {
                    model: [this.$router.currentRoute.query.minPrice ?? this.$store.state.pageModule.pageModel.minCategoryPrice, this.$router.currentRoute.query.maxPrice ?? this.$store.state.pageModule.pageModel.maxCategoryPrice],
                    options: [{ tooltip: 'always' }]
                }
            }
        },
        computed: {
            filters() { return this.$store.state.pageModule.pageModel.products.filterOption; },
            currentMinPrice() { return this.$store.state.pageModule.query.minPrice; },
            currentMaxPrice() { return this.$store.state.pageModule.query.maxPrice; },
            minPrice() { return this.$store.state.pageModule.pageModel.minCategoryPrice; },
            maxPrice() { return this.$store.state.pageModule.pageModel.maxCategoryPrice; }
        },
        beforeMount() { },
        mounted() {
            CatalogAPI.getCategoryHiearchy().then(response => this.menuItems = response.data.result);

            this.mannufacturers.selected = this.$router.currentRoute.query.brands != null ? this.$router.currentRoute.query.brands.split(',')  : []
            this.$store.commit("pageModule/SET_BRAND_FILTER", this.$router.currentRoute.query.brands);
            if(this.$router.currentRoute.query && this.$router.currentRoute.query.query){
              this.$store.commit("pageModule/SET_KEYWORD_FILTER", this.$router.currentRoute.query.query); 
            }
        },
        created() { },
        methods: {
            handlePriceFilter(){
              this.$store.commit("pageModule/SET_PRICE_FILTER", {min: this.priceSlider.model[0], max: this.priceSlider.model[1] });
            },
            handleBrandFilter(e){
              this.$store.commit("pageModule/SET_BRAND_FILTER", e.join(','));
              EventBus.$emit("product-filter");
            },
            handleTagFilter(e){
              this.$store.commit("pageModule/SET_BRAND_FILTER", e.join(','));
            }
        },
    }
</script>

<style lang="scss">
    @import '~vue-slider-component/dist-css/vue-slider-component.css';
    @import '~vue-slider-component/theme/default.css';

    .vue-slider-dot-tooltip-inner {
      font-size: 10px;
      line-height: 1.333;
      text-shadow: none;
      border-radius: 4px;
      border-color: #289b37;
      background-color: #289b37;
    }

    .vue-slider-dot {
      width: 3px;
      height: 18px;
      transform: translate(0px, -50%);
      top: 50%;
      left: 0%;
      transition: left 0.5s ease 0s;
    }

    .vue-slider-dot-handle {
      cursor: pointer;
      width: 100%;
      height: 100%;
      background-color: #289b37;
      box-sizing: border-box;
      box-shadow: none;
    }

    .vue-slider-process {
      background-color: #1f7d2b;
    }

    .sidebar-section.manufacturer .custom-checkbox {
      display: block;
    }

    .custom-checkbox {
        font-size: 0.9rem;
        line-height: 1.56rem;
    }
    
    .mh-filter-btn {
      border: 2px solid #c9c9c9;
      width: 100%;
      background-color: transparent;
      
      &:hover {
        background-color: rgba(0, 0 ,0, 0.05);
        color: #000;
      }
    }

    /*
     TREE MENU
    */
    .mh-treeMenu.theme-catalog {
        padding: 0;
        background-color: #fff;
    

            .mh-treeMenu-item .button-content {
                margin: 0;
                padding: 0 0 0 0.6rem;
            }

            .mh-treeMenu-item .button-content.leaf {
                margin: 0;
                padding: 0 0 0 1.2rem;
            }

            .mh-treeMenu-item .button-content:hover {
                background-color: transparent;
            }

        .mh-treeMenu-item .button-context__button {
            cursor: pointer;
        }

        .mh-treeMenu-item .button__text {
            flex-grow: 1;
            display: flex;
            align-items: center;
            height: 100%;
        }

            .mh-treeMenu-item .button__text .link {
                display: inline-block;
                width: 100%;
                height: 100%;
                font-size: 0.9rem;
                line-height: 30px;
                margin: 0 0;
                padding: 0 0 0 0.6rem;
            }

                .mh-treeMenu-item .button__text .link:hover {
                    color: #000;
                    background-color: #ffffff;
                    border-radius: 4px;
                    text-decoration: underline;
                    font-weight: 400;
                }

            .mh-treeMenu-item .button__text > i {
                font-weight: 600;
                font-size: 10px;
                margin: 0 0.36em 0 0.6em;
            }

                .mh-treeMenu-item .button__text > i.no-margin {
                    margin: 0 0.36em 0 0em;
                }

        .mh-treeMenu-item__children {
            padding-left: 0.8em;
            margin-left: 0.8em;
        }
    }
</style>